<div class="left">
	<h2>
		<ng-content> </ng-content>
	</h2>
</div>

<ng-content select="[end]"></ng-content>
